import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ['messageContainer', 'errorMessage', 'warningMessage', 'successMessage', 'infoMessage'];

  static values = {
    defaultMessage: String,
    previewMessage: String
  }

  connect() {
    this._boundDisplaySuccessMessage = this._displaySuccessMessageFromEvent.bind(this);
    this._boundDisplayErrorMessage = this._displayErrorMessageFromEvent.bind(this);
    this._boundDisplayWarningMessage = this._displayWarningMessageFromEvent.bind(this);
    this._boundDisplayInfoMessage = this._displayInfoMessageFromEvent.bind(this);

    document.addEventListener('promote:display-success-message', this._boundDisplaySuccessMessage);
    document.addEventListener('promote:display-error-message', this._boundDisplayErrorMessage);
    document.addEventListener('promote:display-warning-message', this._boundDisplayWarningMessage);
    document.addEventListener('promote:display-info-message', this._boundDisplayInfoMessage);
  }

  disconnect() {
    document.removeEventListener('promote:display-success-message', this._boundDisplaySuccessMessage);
    document.removeEventListener('promote:display-error-message', this._boundDisplayErrorMessage);
    document.removeEventListener('promote:display-warning-message', this._boundDisplayWarningMessage);
    document.removeEventListener('promote:display-info-message', this._boundDisplayInfoMessage);
  }

  displayStandardErrorMessage() {
    this.displayErrorMessage(this.defaultMessageValue);
  }

  displayPreviewErrorMessage(event) {
    event.preventDefault();
    event.stopPropagation();

    this.displayErrorMessage(this.previewMessageValue);
  }

  displayErrorMessage(message, action=null) {
    this._displayMessage(this.errorMessageTarget, message, action, false);
  }

  displaySuccessMessage(message, action=null) {
    this._displayMessage(this.successMessageTarget, message, action, true);
  }

  displayWarningMessage(message, action=null) {
    this._displayMessage(this.warningMessageTarget, message, action, false);
  }

  displayInfoMessage(message, action=null) {
    this._displayMessage(this.infoMessageTarget, message, action, true);
  }

  _displayMessage(targetMessage, message, action, autoHide) {
    const allMessageTargets = [this.successMessageTarget, this.errorMessageTarget,
      this.warningMessageTarget, this.infoMessageTarget];

    allMessageTargets.forEach((messageElement) => {
      if (messageElement !== targetMessage) {
        messageElement.classList.add('hidden');
      }
    });

    // Hide any flash messages to prevent overlap as they occupy different containers
    document.dispatchEvent(new CustomEvent('promote:hide-flash-message'));

    targetMessage.querySelector('.js-toast-message-text').innerHTML = message;
    targetMessage.classList.remove('hidden');
    this.messageContainerTarget.classList.remove('hidden');

    if (action) {
      this._hideActionLink(targetMessage);
      this._addActionLink(targetMessage, action);
    } else {
      this._hideActionLink(targetMessage);

      if (autoHide) {
        document.dispatchEvent(
          new CustomEvent('promote:hide-toast-message')
        );
      }
    }
  }

  _displaySuccessMessageFromEvent() {
    this.displaySuccessMessage(event.detail.message, event.detail.action);
  }

  _displayErrorMessageFromEvent() {
    this.displayErrorMessage(event.detail.message, event.detail.action);
  }

  _displayWarningMessageFromEvent() {
    this.displayWarningMessage(event.detail.message, event.detail.action);
  }

  _displayInfoMessageFromEvent() {
    this.displayInfoMessage(event.detail.message, event.detail.action);
  }

  _hideActionLink(target) {
    const actionContainer = target.querySelector('.js-toast-message-action');
    actionContainer.innerHTML = '';
    actionContainer.classList.add('hidden');
  }

  _addActionLink(target, action) {
    const actionLink = this._createActionLink(action);
    const actionContainer = target.querySelector('.js-toast-message-action');
    actionContainer.append(actionLink);
    actionContainer.classList.remove('hidden');
  }

  _createActionLink(action) {
    const actionLink = document.createElement('a');
    actionLink.setAttribute('href', action.path);
    actionLink.innerHTML = action.text;

    return actionLink;
  }
}
